import styled from "@emotion/styled";

export const MinWrapper = styled.div`
width: 100%;
// max-width: 1200px;
margin: 5px auto;
display:flex;
justify-content: space-between;
align-items: center;
gap: 10px;
`